module.exports = __webpack_public_path__ + "static/media/clock.2cbadd38.svg";